var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPolygonScatterHaikei(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 1376 768",
    width: 1376,
    height: 768,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(389 429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -148.6L128.7 -74.3L128.7 74.3L0 148.6L-128.7 74.3L-128.7 -74.3Z",
    stroke: "#009688",
    fill: "none",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(912 706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -104L90.1 -52L90.1 52L0 104L-90.1 52L-90.1 -52Z",
    stroke: "#009688",
    fill: "none",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1130 89)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -71L61.5 -35.5L61.5 35.5L0 71L-61.5 35.5L-61.5 -35.5Z",
    stroke: "#009688",
    fill: "none",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -33L28.6 -16.5L28.6 16.5L0 33L-28.6 16.5L-28.6 -16.5Z",
    stroke: "#009688",
    fill: "none",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(637 216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -72L62.4 -36L62.4 36L0 72L-62.4 36L-62.4 -36Z",
    stroke: "#009688",
    fill: "none",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1166 513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -126L109.1 -63L109.1 63L0 126L-109.1 63L-109.1 -63Z",
    stroke: "#009688",
    fill: "none",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15 302)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -95L82.3 -47.5L82.3 47.5L0 95L-82.3 47.5L-82.3 -47.5Z",
    stroke: "#009688",
    fill: "none",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(569 666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -29L25.1 -14.5L25.1 14.5L0 29L-25.1 14.5L-25.1 -14.5Z",
    stroke: "#009688",
    fill: "none",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(370 83)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -93L80.5 -46.5L80.5 46.5L0 93L-80.5 46.5L-80.5 -46.5Z",
    stroke: "#009688",
    fill: "none",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1354 749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -36L31.2 -18L31.2 18L0 36L-31.2 18L-31.2 -18Z",
    stroke: "#009688",
    fill: "none",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(910 353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -142L123 -71L123 71L0 142L-123 71L-123 -71Z",
    stroke: "#009688",
    fill: "none",
    strokeWidth: 2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonScatterHaikei);
export default __webpack_public_path__ + "static/media/polygon-scatter-haikei.4fc0a34202a34d77b6f0d919046caa86.svg";
export { ForwardRef as ReactComponent };